import type { FlowVoiceConfig } from './types';

export type FlowVoicePreset = {
  id: string;
  group: string;
  label: string;
  config: FlowVoiceConfig;
};

export const defaultFlowVoicePreset: FlowVoicePreset = {
  id: 'telnyx-tts',
  group: 'Current TTS Options',
  label: 'Telnyx TTS',
  config: {
    voiceType: 'basic',
    voiceId: 'Telnyx.KokoroTTS.af',
    voiceName: 'Telnyx TTS',
  },
};

export const currentFlowVoicePresets: FlowVoicePreset[] = [
  defaultFlowVoicePreset,
  {
    id: 'polly-standard',
    group: 'Current TTS Options',
    label: 'Standard TTS (Amazon Polly)',
    config: {
      voiceType: 'basic',
      voiceId: 'Polly.Brian',
      voiceName: 'Standard TTS (Amazon Polly)',
    },
  },
  {
    id: 'telnyx-hd',
    group: 'Current TTS Options',
    label: 'Telnyx HD Voices TTS',
    config: {
      voiceType: 'basic',
      voiceId: 'Telnyx.NaturalHD.andersen_johan',
      voiceName: 'Telnyx HD Voices TTS',
    },
  },
  {
    id: 'polly-neural',
    group: 'Current TTS Options',
    label: 'Neural Voices TTS (Amazon Polly)',
    config: {
      voiceType: 'basic',
      voiceId: 'Polly.Amy-Neural',
      voiceName: 'Neural Voices TTS (Amazon Polly)',
    },
  },
  {
    id: 'minimax',
    group: 'Current TTS Options',
    label: 'Minimax TTS',
    config: {
      voiceType: 'basic',
      voiceId: 'Minimax.speech-2.6-turbo.English_expressive_narrator',
      voiceName: 'Minimax TTS',
    },
  },
  {
    id: 'azure-neural-hd',
    group: 'Current TTS Options',
    label: 'Azure Neural HD TTS',
    config: {
      voiceType: 'basic',
      voiceId: 'Azure.en-US-Emma:DragonHDLatestNeural',
      voiceName: 'Azure Neural HD TTS',
    },
  },
];

export const legacyFlowVoicePresets: FlowVoicePreset[] = [
  {
    id: 'alice',
    group: 'Legacy Voices',
    label: 'Alice (Legacy)',
    config: {
      voiceType: 'basic',
      voiceId: 'alice',
      voiceName: 'Alice',
      language: 'en-US',
    },
  },
  {
    id: 'man',
    group: 'Legacy Voices',
    label: 'Man (Legacy)',
    config: {
      voiceType: 'basic',
      voiceId: 'man',
      voiceName: 'Man',
    },
  },
  {
    id: 'woman',
    group: 'Legacy Voices',
    label: 'Woman (Legacy)',
    config: {
      voiceType: 'basic',
      voiceId: 'woman',
      voiceName: 'Woman',
    },
  },
];

export const flowVoicePresets = [...currentFlowVoicePresets, ...legacyFlowVoicePresets];

export const defaultFlowVoiceConfig: FlowVoiceConfig = {
  ...defaultFlowVoicePreset.config,
};

export function findFlowVoicePreset(config: FlowVoiceConfig): FlowVoicePreset | undefined {
  return flowVoicePresets.find(
    (preset) =>
      preset.config.voiceType === config.voiceType &&
      preset.config.voiceId === config.voiceId &&
      preset.config.modelId === config.modelId,
  );
}

export function isLegacyAliceVoice(config: FlowVoiceConfig): boolean {
  return config.voiceType === 'basic' && config.voiceId === 'alice';
}
